/* eslint-disable prettier/prettier */
import i18n from "@/i18n";
import store  from '@/store'
import { MultiselectItem } from "@/models/MultiselectItem";
import { AvailableChannelMetadataTypes, AvailableChannelMetadataTypesMode, ChannelMetadataType, ChannelMetadataTypesForCampaigns, ChannelMetadataTypesForMediaCampaigns } from "@/models/campaigns/ChannelMetadataType";
import { CampaignEditPageKind } from "@/models/campaigns/CampaignEditPageKind";
import { campaignCreateRoute, campaignEditRoute } from "@/router";
import { CampaignStatus } from "@/models/campaigns/CampaignStatus";
import HelperService from "./HelperService";

const namespace = "campaignsModule";

export default {
  getCampaignEditPageKind(path: string): CampaignEditPageKind {
    switch (path) {
      case campaignCreateRoute:
        return CampaignEditPageKind.Create;
      case campaignEditRoute:
        return CampaignEditPageKind.Edit;
    }
    return CampaignEditPageKind.Create;
  },

  getChannelMetadataTypes(mode: AvailableChannelMetadataTypesMode, filter?: string): MultiselectItem[] {
    const result: MultiselectItem[] = [];
    let metadataTypes: ChannelMetadataType[];
    switch (mode) {
      case AvailableChannelMetadataTypesMode.Campaigns:
        metadataTypes = ChannelMetadataTypesForCampaigns;
        break;
      case AvailableChannelMetadataTypesMode.Leads:
        metadataTypes = AvailableChannelMetadataTypes;
        break;
      case AvailableChannelMetadataTypesMode.MediaCampaigns:
        metadataTypes = ChannelMetadataTypesForMediaCampaigns;
        break;
      }
      for (const channelMetadataType of metadataTypes) {     
          const title: string = i18n.t(`Enums.ChannelMetadataType.${ChannelMetadataType[channelMetadataType]}`).toString();      
      if (!filter || title.toLowerCase().indexOf(filter.toLowerCase()) >= 0) {
        result.push({
          ID: channelMetadataType.toString(),
          Title: title,
        });
      }
    }
    return result;
  },

  getChannelMetadataTypeIconName(type: ChannelMetadataType): string {
    switch (type) {
      case ChannelMetadataType.Crm:
        return "hand";
      case ChannelMetadataType.CrmCallCenter:
      case ChannelMetadataType.Phone:
        return "phone";
      case ChannelMetadataType.CrmImport:
        return "excel";
      case ChannelMetadataType.Direct:
        return "direct";
      case ChannelMetadataType.FacebookAdLeadCampaign:
      case ChannelMetadataType.FacebookAdLeadPage:
      case ChannelMetadataType.FacebookAds:
      case ChannelMetadataType.FacebookComments:
      case ChannelMetadataType.FacebookMessenger:
      case ChannelMetadataType.FacebookOrganic:
        return "facebook";
      case ChannelMetadataType.GoogleAdwords:
      case ChannelMetadataType.GoogleLeads:
      case ChannelMetadataType.GoogleOrganic:
        return "google-ads";
      case ChannelMetadataType.InstagramAdLeadCampaign:
      case ChannelMetadataType.InstagramAds:
      case ChannelMetadataType.InstagramComments:
      case ChannelMetadataType.InstagramMessenger:
        return "instagram";
      case ChannelMetadataType.Linkedin:
        return "linkedin";
      case ChannelMetadataType.Newsletter:
        return "newsletter";
      case ChannelMetadataType.Outbrain:
        return "outbrain";
      case ChannelMetadataType.Print:
        return "print";
      case ChannelMetadataType.Referral:
        return "fixdigital";
      case ChannelMetadataType.Radio:
        return "radio";
      case ChannelMetadataType.TV:
        return "tv";
      case ChannelMetadataType.WhatsAppOrganic:
      case ChannelMetadataType.WhatsAppPhone:
        return "whatsapp";
      case ChannelMetadataType.Youtube:
        return "youtube";
      case ChannelMetadataType.TikTokAds:
      case ChannelMetadataType.TikTokLeads:
      case ChannelMetadataType.TikTokOrganic:
        return "tiktok"

    }
    return "";
  },

  getPageSize(): number {
    return 30;
  },

  isFacebook(channelMetadataType: ChannelMetadataType): boolean {
    return [ChannelMetadataType.FacebookAds,
      ChannelMetadataType.FacebookAdLeadCampaign,
      ChannelMetadataType.InstagramAds,
      ChannelMetadataType.InstagramAdLeadCampaign,
    ].includes(channelMetadataType);
  },

  isGoogle(channelMetadataType: ChannelMetadataType): boolean {
    return [ChannelMetadataType.GoogleAdwords, ChannelMetadataType.GoogleLeads].includes(channelMetadataType);
  },

  resetFilters(clientUser: boolean): void {
    store.dispatch(`${ namespace }/setDatePeriod`, HelperService.getThisMonthPeriod(), { root: true });
    store.dispatch(`${ namespace }/setIsMediaChannel`, false, { root: true });
    store.dispatch(`${ namespace }/setSelectedCampaignStatus`, CampaignStatus.Active, { root: true });
    store.dispatch(`${ namespace }/setSelectedChannelMetadataTypesIds`, [], { root: true });
    if (!clientUser) {
      store.dispatch(`${ namespace }/setSelectedClientsIds`, [], { root: true });
    }
    store.dispatch(`${ namespace }/setSelectedCampaignsIds`, [], { root: true });
    store.dispatch(`${ namespace }/setSelectedProjectsIds`, [], { root: true });
  },
};
